import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITrack, ITrackCreate } from '@tsin-core/models/track-management.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const TRACK_URL = `${environment.apiUrl}/tracks`;

@Injectable({
  providedIn: 'root',
})
export class TrackManagementService {
  constructor(private http: HttpClient) {}

  createTrack(track: Omit<ITrackCreate, 'id'>): Observable<ITrack> {
    return this.http.post<ITrack>(TRACK_URL, track);
  }

  updateTrack(track: Omit<ITrackCreate, 'id'>): Observable<ITrack> {
    return this.http.put<ITrack>(TRACK_URL, track);
  }

  getTracks(): Observable<any> {
    return this.http.get<ITrack>(TRACK_URL);
  }

  deleteTrack(id: string): Observable<any> {
    return this.http.delete(`${TRACK_URL}/single/${id}`);
  }
}
